import { render, staticRenderFns } from "./automaticStyle.vue?vue&type=template&id=047cd9b0&"
import script from "./automaticStyle.vue?vue&type=script&lang=js&"
export * from "./automaticStyle.vue?vue&type=script&lang=js&"
import style0 from "./automaticStyle.vue?vue&type=style&index=0&id=047cd9b0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports